import { FIELD_OPTIONS, DATA_FILTER_OPTIONS, SEARCH_BY_OPTIONS } from "../../components/Profiles/constants";

export const initialState = {
  // Modal open/close
  modalOpen: false,

  // Step 1
  selectedCandidates: [],
  selectedFields: FIELD_OPTIONS.reduce((acc, f) => ({ ...acc, [f.key]: true }), {}),
  searchBy: SEARCH_BY_OPTIONS[0],
  dataFilters: DATA_FILTER_OPTIONS.reduce((acc, f) => ({ ...acc, [f.key]: false }), {}),
  searchInput: "",
  searchResults: [],
  isSearching: false,
  dropdownOpen: false,
  dragIndex: null,
  dragOverIdx: null,
  // null = use the default accent (the company branding when saved); set once the user picks one.
  accentColor: null,

  // Step 2
  step: 1,
  columnsPerRow: 2,
  rowGroups: [],
  drag2: null,
  drag2OverRow: null,
};
